<template>
  <div style="height: 400px; max-width: 100%; width: 99%;">
    <Bar :data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
import { Bar } from 'vue-chartjs'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'WeeklySalesBarChart',
  components: { Bar },
  props: {
    labels: { type: Array, required: true }, // ej: ['Lun','Mar','Mié','Jue','Vie','Sáb','Dom']
    data: { type: Array, required: true } // ej: [120, 90, 150, 80, 200, 50, 130]
  },
  computed: {
    chartData () {
      // Calcular promedio
      const sum = this.data.reduce((a, b) => a + b, 0)
      const avg = sum / this.data.length

      // Asignar colores según si supera promedio
      const backgroundColors = this.data.map(v => (v > avg ? '#FF5700' : '#A6A6A6'))

      return {
        labels: this.labels,
        datasets: [
          {
            label: 'Ventas',
            data: this.data,
            backgroundColor: backgroundColors
          }
        ]
      }
    },
    chartOptions () {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          title: { display: false },
          tooltip: {
            callbacks: {
              label: function (context) {
                const value = context.raw
                // Formato con separador de miles estilo "15,000"
                const formatted = value.toLocaleString('es-MX')
                return `${context.dataset.label}: ${formatted}`
              }
            }
          }
        },
        scales: {
          y: { beginAtZero: true }
        }
      }
    }
  }
}
</script>
